import StockReportView from 'src/sections/stock/stock-report/view/stock-report-view';

export default function StockReportPage() {
  return <StockReportView />;
}
